import React from 'react';
import { get } from 'lodash';
import { FieldError as IFieldError, useFormContext } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { Input } from '@morressier/alembic';
import { FieldLabel } from '../Field';
import { IFormFieldText } from '../Submission/GenericFieldComponents/Text';
import FormFieldErrorMessage from './common/FormFieldErrorMessage';
interface IFormFieldTextProps {
  config: IFormFieldText;
  placeholder?: string;
  isEditingAllowed?: boolean;
  ariaLabel?: string;
}

const FormFieldTextInput: React.FC<IFormFieldTextProps> = ({
  config,
  placeholder,
  isEditingAllowed = true,
  ariaLabel
}) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue
  } = useFormContext();

  const {
    name,
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;

  const error = get(errors, field) as IFieldError;
  const value = watch(field) as string;

  const [tempValue, setTempValue] = React.useState<string>(value);

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        label={labels.main}
        subText={labels.subtitle}
        isRequired={validations.required}
        helpText={labels.helpText}
      />
      <Flex flexDirection="column" width="100%" alignItems="flex-start" gap={2}>
        <Input
          id={name}
          value={tempValue}
          {...register(field)}
          isInvalid={!!error}
          placeholder={placeholder || labels.placeholder}
          onChange={e => setTempValue(e.target.value)}
          onBlur={() => {
            setValue(field, tempValue.trim());
          }}
          isReadOnly={!isEditingAllowed}
          min={'minLength' in validations ? validations.minLength : undefined}
          max={'maxLength' in validations ? validations.maxLength : undefined}
          aria-label={ariaLabel}
        />
        <FormFieldErrorMessage config={config} />
      </Flex>
    </Flex>
  );
};

export default FormFieldTextInput;
